import React from 'react';
import { TableRow, TableCell, Link } from '@mui/material';

const CustomerTableRow = ({
  id,
  onClick,
  onClickProvider,
  providerName = '',
  customerName = '',
  type = '',
  customerClass = '',
  status = '',
  authCode = '',
  domain = '',
  ipAddress = '',
}) => (
  <TableRow key={id} id={id}>
    <TableCell>
      <Link tabIndex={0} onClick={() => onClickProvider()}>
        {providerName}
      </Link>
    </TableCell>
    <TableCell>
      <Link tabIndex={0} onClick={() => onClick()}>
        {customerName}
      </Link>
    </TableCell>
    <TableCell>{type}</TableCell>
    <TableCell>{customerClass}</TableCell>
    <TableCell>{status}</TableCell>
    <TableCell>{authCode}</TableCell>
    <TableCell>{domain}</TableCell>
    <TableCell>{ipAddress}</TableCell>
  </TableRow>
);

export default CustomerTableRow;
